import React, { memo } from "react";
import videojs from "video.js";
import VideoJS from "./VideoJS/VideoJS";
import { CaptionOptions, VideoOptions } from "../Types/Types";

const VideoPlayer = (
  { videoOptions, captionOptions = [] }:
    {
      videoOptions: VideoOptions | undefined,
      captionOptions?: CaptionOptions[] | undefined,
    }) => {

  const playerRef = React.useRef(null);

  const handlePlayerReady = (player: any) => {
    playerRef.current = player;

    // Adding fast-forward, rewind, play, pause touch controls.
    // https://github.com/videojs/video.js/issues/6595
    player.on('ready', () => {
      const trackDisplay = document.querySelector(".vjs-text-track-display") as HTMLElement;
      if (trackDisplay === null)
        return;

      trackDisplay.style.pointerEvents = "auto";
      trackDisplay.addEventListener("dblclick", (e) => {
        const videojsElement = document.querySelector(".video-js") as HTMLElement;
        const playerWidth = videojsElement.getBoundingClientRect().width;
        if (0.66 * playerWidth < e.offsetX) {
          player.currentTime(player.currentTime() + 10);
        } else if (e.offsetX < 0.33 * playerWidth) {
          player.currentTime((player.currentTime() - 10) < 0 ? 0 : (player.currentTime() - 10));
        } else {
          if (player.paused()) {
            player.play();
          } else {
            player.pause();
          }
        }
      });
    });

    // You can handle player events here, for example:
    player.on('waiting', () => {
      videojs.log('player is waiting');
    });

    player.on('dispose', () => {
      videojs.log('player will dispose');
    });

    player.on('loadedmetadata', () => {
      videojs.log('loadedmetadata');

      if (captionOptions !== undefined) {
        console.log("captionOptions:", captionOptions);
        for (const captionOpt of captionOptions) {
          player.addRemoteTextTrack(captionOpt, true);
        }
      }
    });
  };

  // This prevent VideoJS to load until it's absolutely ready.
  // VideoJS will not reload even data is changed, so make sure
  // the data is ready before loading it.
  const isVideoJSReadyToLoad = (): boolean => {
    return (videoOptions !== undefined) && (captionOptions !== undefined) &&
      (
        (captionOptions.length === 0) ||
        (captionOptions.length > 0 && captionOptions.every((option) => option.src !== ""))
      );
  };

  return (
    isVideoJSReadyToLoad() ?
      <VideoJS
        options={videoOptions}
        onReady={handlePlayerReady}
      /> :
      <></>
  );

}

export default memo(VideoPlayer);